import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchCurrentSubscription } from "../../api/subscriptionApi";
import useHankoAuth from "../../hooks/useHankoAuth";

export function useSubscription() {
    const queryClient = useQueryClient();
    const { user } = useHankoAuth();
    const userId = user?.id || 'anonymous';

    const { data, isLoading, error } = useQuery({
        queryKey: ["subscription", userId],
        queryFn: async () => await fetchCurrentSubscription(),
        staleTime: 60 * 1000, // 1 minute
        refetchInterval: 2 * 60 * 1000, // 2 minutes background refresh
        refetchOnWindowFocus: true,
    });

    return {
        plan: data,
        loading: isLoading,
        error,
        hasFeature: (feature) => {
            if (!data) return false;
            const override = data.orgFeatureOverrides?.find(o => o.featureKey === feature);
            if (typeof override?.enabled === 'boolean') return override.enabled;
            return data.plan?.features?.includes(feature) === true;
        },
        getLimit: (name) => data?.plan?.[name] ?? 0, // For numerical checks?
        refreshSubscription: () => queryClient.invalidateQueries({ queryKey: ["subscription"] }),
    };
}
